import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SwPush, SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { of, Subscription } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { LayoutUtilsService, MessageType } from './core/_base/crud';
import { LayoutConfigService, SplashScreenService, TranslationService } from './core/_base/layout';
import { SubscriptionService } from './core/_base/layout/services/subscription.service';
import { locale as enLang } from './core/_config/i18n/en';
import { locale as frLang } from './core/_config/i18n/fr';
import { locale as ptLang } from './core/_config/i18n/pt';
import { countriesCode } from './core/_constants/country-codes';
import { AppState } from './core/_reducers';
import { FullWelcomeDialogComponent } from './views/partials/content/full-welcome-dialog/full-welcome.dialog.component';
import { HalfWelcomeDialogComponent } from './views/partials/content/half-welcome-dialog/half-welcome.dialog.component';
import moengage from "@moengage/web-sdk";


declare var my: any;
declare var hj: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy, OnInit, AfterViewInit {

  loader: boolean;
  isMiniApp: boolean;
  welcomeModal: any;
  referrer: string;
  countryCode: string;
  countryNumber: string;
  countryName: string;
  siteName: string;
  redirect: string;
  newVersion = false;
  siteUnderConstruction = false;
  shouldBeInApp = false;
  appSubDomain = window.location.hostname.split('.')[0];
  webviewSrc: string;
  hideCookie = true;
  fromQuickbusPage = false;

  

  readonly VAPID_PUBLIC_KEY = environment.VAPID_PUBLIC_KEY;

  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  constructor(
    private translationService: TranslationService,
    private swUpdate: SwUpdate,
    private route: ActivatedRoute,
    private router: Router,
    private swPush: SwPush,
    private store: Store<AppState>,
    private cookieService: CookieService,
    private layoutConfigService: LayoutConfigService,
    private layoutUtilsService: LayoutUtilsService,
    private subscriptionService: SubscriptionService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private splashScreenService: SplashScreenService,
    private gtmService: GoogleTagManagerService, private translate: TranslateService,
  ) {
    // register translations
    this.translationService.loadTranslations(enLang, ptLang, frLang);
 
  }


  ngOnInit(): void {
    console.log('🟢 App Component Loaded');
    this.translationService.setLanguage(this.translationService.getSelectedLanguage());
    this.isMiniApp = this.layoutConfigService.getConfig('site.isMiniApp');
    this.welcomeModal = this.layoutConfigService.getConfig('site.welcomeModal');
    this.countryCode = this.layoutConfigService.getConfig('site.countryCode');
    this.countryNumber = this.layoutConfigService.getConfig('site.countryNumber');
    this.countryName = this.layoutConfigService.getConfig('site.countryName');
    this.siteName = this.layoutConfigService.getConfig('site.name');
    this.referrer = document.referrer;
    sessionStorage.setItem("referrer", this.referrer);
    this.redirect = this.layoutConfigService.getConfig('site.redirect');
    if (this.redirect) {
      window.location.href = this.redirect.startsWith('https://') ? this.redirect : `https://${this.redirect}`;
    }
    
    moengage.initialize({app_id:'1GHQ8MNLDZE8GX2IS95VZU04',debug_logs: 0,cluster:"DC_2"});
    // moengage.initialize({app_id:'1GHQ8MNLDZE8GX2IS95VZU04_DEBUG',debug_logs: 0,cluster:"DC_2"});

    if (this.swUpdate.isEnabled && !this.isMiniApp) {
      this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
      map(evt => {
        this.newVersion = true;
      }));
      // this.swUpdate.available.subscribe(() => {
      //   this.newVersion = true;
      // });
    }

    this.route.queryParamMap.subscribe(data => {
      const src = data.get('webviewSrc') || sessionStorage.getItem("webviewSrc");
      const miniAppsUrls = [
        "moya.quickbus.com", 
        "moya-dev.quickbus.com",
        "quickbus.moyafree.co"
      ];
      if (isNotNullOrUndefined(src)) {
        this.webviewSrc = src;
        sessionStorage.setItem("webviewSrc", src);
        this.shouldBeInApp = false;
      } else if (miniAppsUrls.includes(window.location.hostname)) {
        this.shouldBeInApp = true;
      }
      const discountCode = data.get('discountCode');
      if (isNotNullOrUndefined(discountCode)) {
        sessionStorage.setItem("discountCode", discountCode);
      }
      const discountText = data.get('discountText');
      if (isNotNullOrUndefined(discountText)) {
        sessionStorage.setItem("discountText", discountText.replace(/percent/g, '%'));
      }
      const redirected = data.get('redirected');
      if (isNotNullOrUndefined(redirected)) {
        setTimeout(() => {
          this.fromQuickbusPage = true;
        }, 1000);
      }
    });

    this.loader = true;

    const routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100);
        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('app-page--loaded');
        }, 500);
      }
    });
    this.unsubscribe.push(routerSubscription);
    

    

    fetch(environment.siteUnderConstructionUrl, {cache: "no-cache"})
    .then(response => response.json())
    .then(data => {
      if (data && data[0] !== "<") {
        const underConstruction = data;
        const site = window.location.hostname.split('.')[0];
        if (underConstruction.all || underConstruction[site]) {
          this.siteUnderConstruction = true;
        }
      }
    }).catch(err => {});

    fetch(environment.updateDate, {cache: "no-cache"})
    .then(response => response.json())
    .then(data => {
      if (data && data[0] !== "<") {
        const newDate = data[environment.environmentName];
        const oldDate = localStorage.getItem("lastForcedCacheUpdate");
        if (newDate) {
          const upDate = moment(newDate, data.format || 'DD-MM-YYYY').valueOf();
          localStorage.setItem("lastForcedCacheUpdate", upDate.toString());
          if (oldDate) {
            if (upDate !== Number(oldDate)) {             
              caches.keys().then(names => {
                names.forEach(cache => caches.delete(cache));
                window.location.reload();
              });
            }
          }
        }
      }
    });
  }

  refresh(): void {
    window.location.reload();
  }

  closeVersionBox() {
    this.newVersion = false;
  }
  closeCookieBox() {
    this.hideCookie = true;
  }
  acceptCookies() {
    localStorage.setItem('cookieSeen', 'accepted');
    this.hideCookie = true;
  }
  closeRedirectBox(e, redirect) {
    if (e) { e.preventDefault() }
    this.fromQuickbusPage = false;
    if (redirect) { window.open("https://quickbus.com/?blockRedirect=true", "_blank") }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (localStorage.getItem('cookieSeen') === 'accepted') {
        this.hideCookie = true;
      } else {
        this.hideCookie = false;
        localStorage.setItem('cookieSeen', 'shown');
      }
    }, 5000);
    if (environment.production && !this.isMiniApp) {
      this.subscribeToNotifications();
    }

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page_load',
          time: new Date().getTime(),
          pageName: item.url
        };
        window.dataLayer.push(gtmTag);
      }
    });

    const userInfo = localStorage.getItem("userInfo");

    if (typeof my === "undefined" && window.location.hostname.includes("vodapay")) {
      this.shouldBeInApp = true;
    }

    if (!this.isMiniApp && !userInfo && this.welcomeModal) {
      const handleModalResult = (result) => {
        if (!result) {
          return;
        }
        if (result.event === 'submit') {
          const payload = result.payload;
          const countryNumber = countriesCode.find(a => payload.phone.replace('+','').startsWith(a.code))?.code || this.countryNumber;
          localStorage.setItem("userInfo", JSON.stringify(payload));
          const notify = this.layoutUtilsService.showActionNotification(this.welcomeModal.discount || 'You will receive promotions and discounts', undefined, 30000, false);
          setTimeout(() => {
            notify.dismiss();
          }, 3000);
        }
      }

      try {
        switch (this.welcomeModal.type) {
          case 'half':
              setTimeout(() => {
                const dialogRef = this.dialog.open(
                  HalfWelcomeDialogComponent,
                  {
                    data: {
                      text: this.welcomeModal.text,
                      referrer: this.referrer,
                      url: window.location.href,
                      userAgent: window.navigator.userAgent
                    },
                    maxHeight: '95%',
                    height: 'auto',
                    maxWidth: '95%',
                    width: '500px',
                    panelClass: 'welcome-dialog',
                    disableClose: true
                  }
                );
                dialogRef.afterClosed().subscribe(result => handleModalResult(result));
              }, (this.welcomeModal.showTime || 10) * 1000);
            break;
          case 'full':
            setTimeout(() => {
              const dialogRef = this.dialog.open(
                FullWelcomeDialogComponent,
                {
                  data: {
                    text: this.welcomeModal.text,
                    operators: this.welcomeModal.operators,
                    referrer: this.referrer,
                    url: window.location.href,
                    userAgent: window.navigator.userAgent
                  },
                  height: '100%',
                  width: '100%',
                  panelClass: ['welcome-dialog', 'welcome-dialog--full'],
                  disableClose: true
                }
              );
              dialogRef.afterClosed().subscribe(result => handleModalResult(result));
            }, 100);
            break;

          default:
            break;
        }
      } catch (error) {}
    }

    const user = userInfo ? JSON.parse(userInfo) : undefined;
    let hjChecker = 0;
    const hjCheck = setInterval(() => {
      if ((typeof hj !== 'undefined') && hj && user && user.phone) {
        hj('identify', user.phone.replace('+', ''), {
          email: user.email
        });
        clearInterval(hjCheck);
      }
      hjChecker++;
      if (hjChecker === 5) {clearInterval(hjCheck)};
    }, 2000);
    
  }

  subscribeToNotifications() {
    this.swPush
      .requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY
      })
      .then(sub => {
        const payload = {
          subscription_json: sub
        };
        return this.subscriptionService.addPushSubscriber(payload).subscribe();
      })
      .catch(err => {
          return false;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(sb => sb.unsubscribe());
  }


}